import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconCards = function IconCards(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 6a3 3 0 013 3v24a3 3 0 01-3 3h-3v3a3 3 0 01-3 3H3a3 3 0 01-3-3V21h42v12h3V9H9v3h30a3 3 0 013 3v3H0v-3a3 3 0 013-3h3V9a3 3 0 013-3h36zM15 26H8a2 2 0 00-1.995 1.851L6 28v3a2 2 0 001.851 1.995L8 33h7a2 2 0 001.995-1.851L17 31v-3a2 2 0 00-1.851-1.995L15 26z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 6a3 3 0 013 3v24a3 3 0 01-3 3h-3v3a3 3 0 01-3 3H3a3 3 0 01-3-3V15a3 3 0 013-3h3V9a3 3 0 013-3h36zm-6 15H3v18h36V21zm-24 4a3 3 0 013 3v3a3 3 0 01-3 3H9a3 3 0 01-3-3v-3a3 3 0 013-3h6zM45 9H9v3h30a3 3 0 013 3v18h3V9zM15 28H9v3h6v-3zm24-13H3v3h36v-3z"
  })));
};

export default IconCards;
